import { render, staticRenderFns } from "./EcocarotidiList.vue?vue&type=template&id=4970d5cc"
import script from "./EcocarotidiList.vue?vue&type=script&lang=js"
export * from "./EcocarotidiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports